import { config } from '@abyss/ui/tools/config';
import { getFeature } from 'src/tools/features';
import { useQuery } from '../../tools/useQuery';
import {
  userInfoActions,
  useUserInfoStore,
} from '../../store/useUserInfoStore';

const url = `${
  getFeature('OHID_SESSION_REWORK')
    ? `${config('IDENTITY_API_URL')}/userinfo/v2`
    : `${config('IDENTITY_API_URL')}/userinfo`
}`;

const parseResult = result => {
  const initialState = {};

  if (result) {
    return result;
  }

  return initialState;
};

export const useUserInfo = options => {
  const { data: cachedData, isInitialized } = useUserInfoStore();

  const queryOptions = options || {};
  queryOptions.method = 'GET';

  const [queryResult, queryAction] = useQuery(url, {
    ...queryOptions,
    onCompleted: result => {
      const parsedData = parseResult(result.body);
      userInfoActions.setData(parsedData);

      if (options && options.onCompleted) {
        options.onCompleted(parsedData);
      }
    },
  });

  if (isInitialized && cachedData) {
    return [
      {
        data: cachedData,
      },
      queryAction,
    ];
  }

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
